import { ERROR_409 } from 'common/config/api';
import {
  SERVICES_AN_ERROR_OCCURRED_CREATING,
  SERVICES_AN_ERROR_OCCURRED_DELETING,
  SERVICES_AN_ERROR_OCCURRED_LOADING,
  SERVICES_AN_ERROR_OCCURRED_UPDATING,
  SERVICES_SUCCESSFULLY_CREATED,
  SERVICES_SUCCESSFULLY_DELETED,
  SERVICES_SUCCESSFULLY_UPDATED,
} from 'common/constants/services/services';
import {
  FUND_INVESTMENTS_PUBLIC_COMPS_DIALOG_INDEXES_ETFS_FUNDS_COMPANIES_TITLE,
  FUND_INVESTMENTS_TITLE_SINGULAR,
} from 'pages/FundInvestments/common/constants';
import { ErrorMessages } from './fundInvestments.types';

export const SERVICES_FUND_INVESTMENTS_REFETCH_ON_WINDOW_FOCUS = false;

// Create fund investment
export const CREATE_FUND_INVESTMENT_TITLE = FUND_INVESTMENTS_TITLE_SINGULAR;
export const CREATE_FUND_INVESTMENT_DEFAULT_ERROR_MESSAGE
  = SERVICES_AN_ERROR_OCCURRED_CREATING(CREATE_FUND_INVESTMENT_TITLE);
export const CREATE_FUND_INVESTMENT_DEFAULT_SUCCESS_MESSAGE = (fundInvestmentName: string) =>
  SERVICES_SUCCESSFULLY_CREATED(`${CREATE_FUND_INVESTMENT_TITLE}: ${fundInvestmentName}`);

// Update fund investment
export const UPDATE_FUND_INVESTMENT_TITLE = FUND_INVESTMENTS_TITLE_SINGULAR;
export const UPDATE_FUND_INVESTMENT_DEFAULT_ERROR_MESSAGE
  = SERVICES_AN_ERROR_OCCURRED_UPDATING(UPDATE_FUND_INVESTMENT_TITLE);
export const UPDATE_FUND_INVESTMENT_DEFAULT_SUCCESS_MESSAGE = (fundInvestmentName: string) =>
  SERVICES_SUCCESSFULLY_UPDATED(`${UPDATE_FUND_INVESTMENT_TITLE}: ${fundInvestmentName}`);

// Delete fund investment
export const DELETE_FUND_INVESTMENT_TITLE = FUND_INVESTMENTS_TITLE_SINGULAR;
export const DELETE_FUND_INVESTMENT_DEFAULT_ERROR_MESSAGE
  = SERVICES_AN_ERROR_OCCURRED_DELETING(DELETE_FUND_INVESTMENT_TITLE);
export const DELETE_FUND_INVESTMENT_DEFAULT_SUCCESS_MESSAGE
  = SERVICES_SUCCESSFULLY_DELETED(DELETE_FUND_INVESTMENT_TITLE);

export const FUND_INVESTMENT_NAME_ALREADY_EXISTS_ERROR_MESSAGE = `A ${FUND_INVESTMENTS_TITLE_SINGULAR} with this name already exists`;
export const FUND_INVESTMENT_SERVICES_ERROR_MESSAGES: ErrorMessages = {
  [ERROR_409]: FUND_INVESTMENT_NAME_ALREADY_EXISTS_ERROR_MESSAGE,
};

// Fund investment by allocation
export const FUND_INVESTMENT_BY_ALLOCATION_QUERY_KEY = 'FUND_INVESTMENT_BY_ALLOCATION';
export const FUND_INVESTMENT_BY_ALLOCATION_TITLE = FUND_INVESTMENTS_TITLE_SINGULAR;
export const FUND_INVESTMENT_BY_ALLOCATION_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FUND_INVESTMENT_BY_ALLOCATION_TITLE
);

// Update fund investment details
export const UPDATE_FUND_INVESTMENT_DETAILS_TITLE = FUND_INVESTMENTS_TITLE_SINGULAR;
export const UPDATE_FUND_INVESTMENT_DETAILS_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_UPDATING(
  UPDATE_FUND_INVESTMENT_DETAILS_TITLE
);
export const UPDATE_FUND_INVESTMENT_DETAILS_DEFAULT_SUCCESS_MESSAGE = SERVICES_SUCCESSFULLY_UPDATED(
  UPDATE_FUND_INVESTMENT_DETAILS_TITLE
);

// Public comps and indexes by date
export const PUBLIC_COMPS_AND_INDEXES_BY_DATE_QUERY_KEY = 'PUBLIC_COMPS_AND_INDEXES_BY_DATE';
export const PUBLIC_COMPS_AND_INDEXES_BY_DATE_TITLE
  = FUND_INVESTMENTS_PUBLIC_COMPS_DIALOG_INDEXES_ETFS_FUNDS_COMPANIES_TITLE;
export const PUBLIC_COMPS_AND_INDEXES_BY_DATE_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  PUBLIC_COMPS_AND_INDEXES_BY_DATE_TITLE
);
